var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "reference-house" }, [
    _vm.hasImage
      ? _c("div", {
          staticClass: "reference-house-image",
          style: { "background-image": _vm.refHouseImage }
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "reference-house-description" }, [
      _c("h3", [_vm._v(_vm._s(_vm.refHouse.name))]),
      _vm._v(" "),
      _vm.refHouse.matchCriteria
        ? _c("span", { staticClass: "title-right" }, [_vm._v("(Bra val)")])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ul",
        [
          _c("li", [
            _c("strong", [_vm._v(_vm._s(this.productLabel))]),
            _vm._v(": " + _vm._s(_vm.refHouse.product.productName))
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              _vm._s(_vm.refHouse.minNumberOfFloors) +
                "–" +
                _vm._s(_vm.refHouse.maxNumberOfFloors) +
                " våningar"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              _vm._s(_vm.refHouse.standardFloorNumberOfApartments) +
                " bostäder per normalplan"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              _vm._s(_vm.refHouse.standardFloorLivingArea) +
                " kvm (BOA) per normalplan"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c("strong", [_vm._v("Bostadstyper")]),
            _vm._v(":\n                "),
            _c(
              "ul",
              { staticClass: "reference-house-description-list" },
              _vm._l(_vm.sortBySize(_vm.apartments), function(apartment) {
                return _c("li", [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm.apartmentSizeDict.find(function(size) {
                          return size.id === apartment.size
                        }).label
                      ) +
                      ", " +
                      _vm._s(apartment.area) +
                      " kvm\n                    "
                  )
                ])
              })
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c("strong", [_vm._v("Fasad:")]),
            _vm._v(
              " " + _vm._s(_vm.refHouse.facadeDescription) + "\n            "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c("strong", [_vm._v("Tak:")]),
            _vm._v(
              " " + _vm._s(_vm.refHouse.roofDescription) + "\n            "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c("strong", [_vm._v("Stomme:")]),
            _vm._v(
              " " + _vm._s(_vm.refHouse.frameDescription) + "\n            "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c("strong", [_vm._v("Energiförbrukning:")]),
            _vm._v(
              " " + _vm._s(_vm.refHouse.powerConsumption) + " per kvm & år"
            )
          ]),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("strong", [_vm._v("Grundpris:")]),
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm._f("prettyNumber")(_vm.refHouse.defaultBasePrice)
                  ) +
                  " per BOA + LOA\n                "
              ),
              _c("help-box", {
                attrs: {
                  title: "BOA + LOA",
                  message:
                    "Bostadshuset exkl grundläggning, markarbeten och moms.",
                  "message-ref": "carousel-" + _vm.refHouse.id
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("li", [
            _c("strong", [_vm._v("Leverantör:")]),
            _vm._v(" " + _vm._s(_vm.refHouse.developer) + "\n            ")
          ]),
          _vm._v(" "),
          _c("li", [_vm._v(" ")]),
          _vm._v(" "),
          _vm.refHouse.limitedGeographicalAvailability
            ? [
                _vm._m(0),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.refHouse.limitedGeographicalAvailabilityNote)
                  )
                ])
              ]
            : _vm._e()
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("strong", [_vm._v("OBS!")]),
      _vm._v(" Begränsad tillgänglighet")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{}!./~/vue-loader/lib?{}!./assets/vue/houseModel/components/refHouse.vue?vue&type=template&id=1903bd97&
// module id = 502
// module chunks = 0